// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";

import '../../../../input.css'
;

var files = "my.song.mp3 11b\ngreatSong.flac 1000b\nnot3.txt 5b\nvideo.mp4 200b\ngame.exe 100b\nmov!e.mkv 10000b";

var fileSizeCalculation = (function (fileList) {
    let resultSize = [0, 0, 0, 0];
    fileList.split("\n").forEach((list) => {
      if (list === "") {
        return;
      }

      const temp = list.split(" ");
      if (temp.length !== 2) {
        return;
      }

      const typeArr = temp[0].split(".");
      const type = typeArr[typeArr.length - 1];
      const size = temp[1].split("b");
      if (type === "mp3" || type === "aac" || type === "flac") {
        resultSize[0] += parseInt(size[0]);
      } else if (type === "jpg" || type === "bmp" || type === "gif") {
        resultSize[1] += parseInt(size[0]);
      } else if (type === "mp4" || type === "avi" || type === "mkv") {
        resultSize[2] += parseInt(size[0]);
      } else {
        resultSize[3] += parseInt(size[0]);
      }
    });

    let result = [];
    result.push("music " + resultSize[0] + "b");
    result.push("images " + resultSize[1] + "b");
    result.push("movies " + resultSize[2] + "b");
    result.push("other " + resultSize[3] + "b");
    return result;
  });

function FileSizeCalculation(Props) {
  var match = React.useState(function () {
        return files;
      });
  var setfilesList = match[1];
  var filesList = match[0];
  var handleFilesListChange = function ($$event) {
    var value = $$event.currentTarget.value;
    Curry._1(setfilesList, (function (param) {
            return value;
          }));
  };
  var fileSizeCalitems = fileSizeCalculation(filesList).map(function (file, index) {
        return React.createElement("li", {
                    key: String(index)
                  }, file);
      });
  return React.createElement("section", undefined, React.createElement("h2", {
                  className: "text-center text-xl font-bold mt-10 mb-2"
                }, "File Size Calculation Challenge"), React.createElement("div", {
                  className: "flex flex-wrap max-w-[1200px] mx-auto justify-around"
                }, React.createElement("div", {
                      className: "mx-5 mb-3"
                    }, React.createElement("h3", {
                          className: "max-w-[350px]"
                        }, "You want to know how many bytes of memory each file type is consuming. Each file has a name, and the part of the name after the last dot is called the file extension, which identifies what type of file it is. We distinguish four broad types of file:"), React.createElement("ul", {
                          className: "max-w-[300px] mb-3"
                        }, React.createElement("li", undefined, "• music (only extensions: mp3, aac, flac)"), React.createElement("li", undefined, "• Image (only extensions: jpg, bmp.gif)"), React.createElement("li", undefined, "• movie (only extensions: mp4, avi, mkv)"), React.createElement("li", undefined, "• other (all other extensions; for example: 7z, txt, zip)")), React.createElement("p", {
                          className: "pb-2"
                        }, "Input a list of files"), React.createElement("textarea", {
                          className: "p-2 rounded-lg",
                          id: "filesListInput",
                          style: {
                            resize: "none"
                          },
                          cols: 30,
                          rows: 5,
                          value: filesList,
                          onChange: handleFilesListChange
                        })), React.createElement("pre", {
                      className: "transition max-w-[500px] h-[400px] mx-5 mb-3 p-5 overflow-scroll bg-red-300 rounded-xl drop-shadow-lg hover:drop-shadow-2xl"
                    }, React.createElement("code", undefined, "function (fileList) {\n  let resultSize = [0, 0, 0, 0];\n  fileList.split(\"\\n\").forEach((list) => {\n    if (list === \"\") {\n      return;\n    }\n\n    const temp = list.split(\" \");\n    if (temp.length !== 2) {\n      return;\n    }\n    \n    const typeArr = temp[0].split(\".\");\n    const type = typeArr[typeArr.length - 1];\n    const size = temp[1].split(\"b\");\n    if (type === \"mp3\" || type === \"aac\" || type === \"flac\") {\n      resultSize[0] += parseInt(size[0]);\n    } else if (type === \"jpg\" || type === \"bmp\" || type === \"gif\") {\n      resultSize[1] += parseInt(size[0]);\n    } else if (type === \"mp4\" || type === \"avi\" || type === \"mkv\") {\n      resultSize[2] += parseInt(size[0]);\n    } else {\n      resultSize[3] += parseInt(size[0]);\n    }\n  });\n\n  let result = [];\n  result.push(\"music \" + resultSize[0] + \"b\");\n  result.push(\"images \" + resultSize[1] + \"b\");\n  result.push(\"movies \" + resultSize[2] + \"b\");\n  result.push(\"other \" + resultSize[3] + \"b\");\n  return result;\n}\n")), fileSizeCalitems.length !== 0 ? React.createElement("div", {
                        className: "transition min-w-[150px] h-[150px] mx-5 mb-3 p-5 bg-red-200 rounded-xl overflow-y-scroll drop-shadow-lg hover:drop-shadow-2xl"
                      }, fileSizeCalitems) : React.createElement(React.Fragment, undefined)));
}

var make = FileSizeCalculation;

export {
  files ,
  fileSizeCalculation ,
  make ,
}
/*  Not a pure module */
